import pubs from "../../api/pub";

export default {
  namespaced: true,
  state: {
    items: [],
    activeItem: null,
    editedId: -1,
    editedItem: {
      name: "",
      description: "",
      link: "",
      imagePath: "",
      imageData: null,
      startDate: new Date(),
      endDate: new Date(Date.now() + 24 * 60 * 60 * 1000), // endDate = aujourd'hui + 1 jour
      position: null,
      active: false,
    },
    defaultItem: {
      name: "",
      description: "",
      link: "",
      imagePath: "",
      imageData: null,
      startDate: new Date(),
      endDate: new Date(Date.now() + 24 * 60 * 60 * 1000), // endDate = aujourd'hui + 1 jour
      position: null,
      active: false,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        name: item.name,
        description: item.description,
        link: item.link,
        imagePath: item.imagePath,
        imageData: item.imageData,
        startDate: item.startDate,
        endDate: item.endDate,
        position: item.position,
        active: item.active,
      };
      state.editedItem = editedItem;
    },
    setEditedEndDate(state, endDate) {
      state.editedItem.endDate = endDate;
    },
    setEditedStartDate(state, startDate) {
      state.editedItem.startDate = startDate;
    },
    setActiveItem(state, item) {
      state.activeItem = item;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
  },
  actions: {
    fetchActive({ commit }) {
      return pubs.getActive().then((response) => {
        commit("setActiveItem", response.data[0]);
        return response;
      });
    },
    fetchAll({ commit }, data) {
      return pubs.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    saveEditedItem({ dispatch, state }, imageFile) {
      const formData = new FormData();

      // Ajouter toutes les propriétés de l'élément édité au FormData
      Object.keys(state.editedItem).forEach((key) => {
        if (key === "startDate") {
          const date = new Date(state.editedItem[key]);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          formData.append(key, `${year}-${month}-${day}`);
        } else if (key === "endDate") {
          const date = new Date(state.editedItem[key]);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          // Format YYYY-MM-DDT23:59:59 (ISO sans timezone)
          formData.append(key, `${year}-${month}-${day}T23:59:59`);
        } else {
          formData.append(key, state.editedItem[key]);
        }
      });
      formData.append("imageFile", imageFile);

      return pubs.storeWithImage(formData).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    updateEditedItem({ dispatch, state }, imageFile) {
      const formData = new FormData();

      // Ajouter toutes les propriétés de l'élément édité au FormData
      Object.keys(state.editedItem).forEach((key) => {
        if (key === "startDate") {
          const date = new Date(state.editedItem[key]);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          formData.append(key, `${year}-${month}-${day}`);
        } else if (key === "endDate") {
          const date = new Date(state.editedItem[key]);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          // Format YYYY-MM-DDT23:59:59 (ISO sans timezone)
          formData.append(key, `${year}-${month}-${day}T23:59:59`);
        } else {
          formData.append(key, state.editedItem[key]);
        }
      });
      formData.append("imageFile", imageFile);

      return pubs.updateWithImage(state.editedId, formData).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    deleteItem(context, id) {
      return pubs.delete(id);
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
